// TODO: rewrite code without try/catch
/* eslint no-empty: 0 */
import { Model } from 'backbone';

import stringToUrl from 'source/lib/utils/string_to_url';

const STORAGE = Symbol('storage');
const DYNAMIC = Symbol('dynamic');

const SettingsModel = Model.extend({
    initialize(attributes = {}, options = {}) {
        this.appName = options.appName || 'wgn';
        this.set({
            urls: {
                SettingsUrl: window.SETTINGS_API_URL || this.get('SETTINGS_API_URL'),
                AccountStateUrl: window.ACCOUNT_STATE_API_URL || this.get('ACCOUNT_STATE_API_URL'),
            },
        });

        this[STORAGE] = `${this.appName}_settings`;
        Model.prototype.initialize.call(this, attributes, options);
        const storedAttr = this.getStoreSettings();

        this.set(storedAttr);
        if (this.get('LEAD_SYNC')) {
            this.startSync();
        }
    },
    getStoreSettings() {
        try {
            return JSON.parse(unescape(localStorage.getItem(this[STORAGE])));
        } catch (e) {
            return {};
        }
    },
    onUpdate() {
        return new Promise((resolve) => {
            if (this.updated) {
                resolve();
            } else {
                this.once('update', () => {
                    resolve();
                });
            }
        });
    },
    startSync(silent = false) {
        this.updated = false;
        return Promise.all([
            this.syncBaseSettings(),
            this.syncAccountState(),
            Promise.resolve(silent),
        ]).then(this.settingsFetchSuccess.bind(this));
    },
    startUpdate(silent = false) {
        this.updated = false;
        return Promise.all([
            Promise.resolve(null),
            this.syncAccountState(),
            Promise.resolve(silent),
        ]).then(this.settingsFetchSuccess.bind(this));
    },
    syncBaseSettings() {
        if (this.get('expiresCache') > (new Date()).getTime()) {
            return Promise.resolve(null);
        }
        const settingsUrl = this.get('urls.SettingsUrl');

        return new Promise((resolve) => {
            this.fetch({
                method: 'GET',
                url: settingsUrl,
            }).then(resolve).catch(() => {
                resolve(null);
            });
        });
    },
    syncAccountState() {
        const query = new URLSearchParams(window.location.search);
        const accountStateURL = stringToUrl(this.get('urls.AccountStateUrl'));
        const passThroughParameters = window.STATE_PASS_THROUGH_PARAMETERS || [];

        passThroughParameters.forEach(key => {
            const value = query.get(key);
            if (value) {
                accountStateURL.searchParams.set(key, value);
            }
        });
        if (this.get('General.LanguageCode')) {
            accountStateURL.searchParams.set('language', this.get('General.LanguageCode'));
        }
        return new Promise((resolve) => {
            this.fetch({
                method: 'GET',
                url: accountStateURL.toString(),
            }).then(resolve).catch(() => {
                resolve(null);
            });
        });
    },

    prepareSettingsResult(settingsResult) {
        let providersWithAutoGeneratedName = settingsResult
            && settingsResult.Authentication
            && settingsResult.Authentication.ExternalRegistrationProvidersWithAutoGeneratedName;
        providersWithAutoGeneratedName = Array.isArray(providersWithAutoGeneratedName)
            ? providersWithAutoGeneratedName
            : [];

        return {
            ...settingsResult,
            Authentication: {
                ...settingsResult.Authentication,
                ExternalRegistrationProvidersWithAutoGeneratedName: providersWithAutoGeneratedName,
            },
        };
    },

    settingsFetchSuccess([settingsResult, stateResult, silent]) {
        this[DYNAMIC] = stateResult;
        if (settingsResult) {
            const settings = this.prepareSettingsResult(settingsResult);
            const now = new Date();
            const lifeTime = settings.SETTINGS_CACHE_LIFETIME
                || this.get('SETTINGS_CACHE_LIFETIME');
            const expiresCache = now.getTime() + (1000 * lifeTime);
            const storeSettings = Object.assign(settings, { expiresCache });

            try {
                localStorage.setItem(this[STORAGE], escape(JSON.stringify(storeSettings)));
            } catch (e) {
                console.log('Can not store settings in private mode.');
            }
            this.set(settings);
        }
        if (stateResult) {
            this.set(stateResult);
        }
        this.updated = true;
        if (!silent) {
            this.trigger('update');
        }
        return Promise.resolve(true);
    },
    extract(context, key) {
        const k = key.shift();

        const property = context[k];
        if (typeof property === 'undefined' || key.length === 0) {
            return property;
        }
        return this.extract(property, key);
    },
    get(key, def) {
        if (typeof key === 'string' && key.length > 0) {
            const keys = key.split('.');
            const value = this.extract(this.attributes, keys);
            return value || def;
        }
        return this.attributes;
    },
    extend(target, source) {
        if (!(source instanceof Object)) {
            return source;
        }
        if (source instanceof Array) {
            return source.map(item => this.extend(null, item));
        }
        const keys = Object.keys(source);
        return keys.reduce((merged, key) => {
            const item = source[key];
            return Object.assign(merged, { [key]: this.extend(target ? target[key] : null, item) });
        }, target || {});
    },
    set(attributes) {
        if (!(attributes instanceof Object) || attributes instanceof Array) {
            return;
        }
        this.extend(this.attributes, attributes);
    },
});

export default SettingsModel;
